export function getRightArrowState(props) {
    return props.containerWidth - props.wrapperWidth + props.offset > 0 ?
        true :
        false;
}
//# sourceMappingURL=getRightArrowState.js.map